/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElDatePicker as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f8ce2818"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单金额", -1));
import dayjs from 'dayjs';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGSIncomeOrderList } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'chargeDetail',
  props: {
    gameId: {
      type: Number,
      default: undefined
    },
    currencyList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const currentCurrency = ref('USD');
    const activeKey = ref('chargeDetail');
    const panes = ref([{
      title: '充值明细',
      key: 'chargeDetail'
    }]);
    const filter = reactive({
      role_id: '',
      role_name: '',
      date: []
    });
    const columns = [{
      label: '角色ID',
      prop: 'roleId',
      width: 100
    }, {
      label: '角色昵称',
      prop: 'roleName'
    }, {
      label: '订单商品',
      prop: 'goodsName'
    }, {
      label: '订单金额',
      prop: 'currencyAmount',
      header: 'amount_header'
    }, {
      label: '下单时间',
      prop: 'create_time',
      slot: 'create_time'
    }];
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGSIncomeOrderList({
        ...filter,
        date: filter.date && filter.date.length ? `${dayjs(filter.date[0]).format('YYYY-MM-DD')} - ${dayjs(filter.date[1]).format('YYYY-MM-DD')}` : undefined,
        is_over_view: 1,
        current_page: current.value,
        page_size: pageSize.value,
        game_id: props.gameId,
        currency: currentCurrency.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.meta && res.meta.pagination && res.meta.pagination.total || 0;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange,
      handleSearch
    } = UseTable(getTableData);
    watch(() => props.gameId, val => {
      if (val) getTableData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_date_picker = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_option = __unplugin_components_5;
      const _component_el_select = __unplugin_components_6;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(activeKey) ? activeKey.value = $event : null),
        panes: _unref(panes),
        class: "margin-pane"
      }, {
        "left-extra": _withCtx(() => [_createVNode(_component_el_form, {
          inline: "",
          class: "search-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "140px"
              },
              placeholder: "请输入角色ID",
              modelValue: _unref(filter).role_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).role_id = $event),
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "140px"
              },
              placeholder: "请输入角色昵称",
              modelValue: _unref(filter).role_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).role_name = $event),
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(filter).date,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).date = $event),
              style: {
                "width": "280px"
              },
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSearch)
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        extra: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(currentCurrency),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(currentCurrency) ? currentCurrency.value = $event : null),
          style: {
            "width": "160px"
          },
          onChange: getTableData
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currencyList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.currency
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        default: _withCtx(() => [_createVNode(UTable, {
          loading: _unref(tableLoading),
          "row-key": "id",
          options: columns,
          data: _unref(tableData),
          total: _unref(total),
          pagination: "",
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          create_time: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.create_time)), 1)]),
          amount_header: _withCtx(() => [_hoisted_1, _createTextVNode("(" + _toDisplayString(_unref(currentCurrency)) + ") ", 1)]),
          _: 1
        }, 8, ["loading", "data", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});